<div class="fulfillmentLanding container-return-wrapper associate-crop-landing">
  <div class="containerReturnsLandingPage">
    <div class="row plotSeedHeader">
        <div class="order-view-sec breadcrumbOuter padding-0" id="orderView" [ngClass]="{
'col-md-9':orderViewtoggle == false,
'col-md-12':orderViewtoggle == true}">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb pt-0">
              <li class="breadcrumb-item active">
                <a href="javascript:void(0)" (click)="navigateToReleaseLanding()">Plot Seed Release</a>
                <i class="fas fa-angle-right"></i>
              </li>
              <li class="breadcrumb-item breadcrumbColor" aria-current="page">
                <span>Review Release</span>
              </li>
            </ol>
          </nav>
        </div>
    </div>

    <div class="row plotSeedFilterSection">
      <div class="col-lg-11 col-md-9 pr-0">
        <app-filter [(optionsData)]="filterOptionsData" [isSearchButtonOutside]="true" (exportClick)="export()" (searchClick)="filterSearchClick($event)" (clearAllClick)="filterClearAllClick($event)"></app-filter>
      </div>
      <div>
        <button mat-raised-button class="btns xs-button xs-full-width exportBtn" [disabled]="(plotSeedDataSource && plotSeedDataSource.data.length == 0)" (click)="export()">Export</button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 legend-outer">
        <div class="d-flex justify-content-end btnWrap">
          <button mat-raised-button class="btns newOrderBtn" color="primary" (click)="navigateToReleaseLanding()">Return to Plot Seed Release</button>
        </div>
        <mat-tab-group class="matTabs prepayLandingTab" (selectedTabChange)="tabChanged($event)" [selectedIndex]="currentTab">
          <mat-tab>
            <ng-template mat-tab-label>
              <i class="icon-ico-dealer_icon padding-t10 xs-mr-5" aria-hidden="true"></i>
              <div class="tab-head">
                <h4 class="mt-2 ml-2 mb-0">
                  JDE Order Sync
                </h4>
              </div>
            </ng-template>
            <div class="fulfill-top-sec">
              <div class="row listing-action-items">
                <div class="col-12">
                  <div class="d-flex justify-content-end">                
                    <mat-paginator #plotSeedPaginator [pageSize]="masterConstants.PAGE_SIZE" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS"></mat-paginator>
                  </div>
                </div>
              </div>
            </div>
            <div class="tableContainer activeReturnRequest">
              <table mat-table #plotSeedTable [dataSource]="plotSeedDataSource" matSort #plotSeedSort matSortDirection="desc" class="matTables containerDrafTable">
                <ng-container matColumnDef="jdePlotSeedSyncId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">JDE Plot Seed Sync ID</th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    {{element.jdePlotSeedSyncId}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="companyCode">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo  text-center">JDE Company Code</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.companyCode}} </td>
                </ng-container>
                <ng-container matColumnDef="jdeOrderNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">JDE Order Number</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    {{element.jdeOrderNumber}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="jdeOrderType">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">JDE Order Type</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    {{element.jdeOrderType}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="jdeOrderLineNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">JDE Order Line Number</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    {{element.jdeOrderLineNumber}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="customerPO">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Customer PO</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    {{element.customerPO}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="deliveryInstruction1">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Delivery Instruction 1</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    {{element.deliveryInstruction1}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="deliveryInstruction2">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Delivery Instruction 2</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    {{element.deliveryInstruction2}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="webOrderNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Web Order Number</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    {{element.webOrderNumber}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="webOrderNumberLineNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Web Order Number Line Number</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    {{element.webOrderNumberLineNumber}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="freightHandlingCode">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Freight Handling Code</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.freightHandlingCode}} </td>
                </ng-container>
                <ng-container matColumnDef="orderDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Order Date</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.orderDate | date:'MM/dd/yyyy'}} </td>
                </ng-container>
                <ng-container matColumnDef="requestedDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Requested Date</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.requestedDate | date:'MM/dd/yyyy'}} </td>
                </ng-container>
                <ng-container matColumnDef="shipDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Ship Date</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.shipDate | date:'MM/dd/yyyy'}} </td>
                </ng-container>
                <ng-container matColumnDef="invoiceDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Invoice Date</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.invoiceDate | date:'MM/dd/yyyy'}} </td>
                </ng-container>
                <ng-container matColumnDef="cropYear">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">Crop Year</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.cropYear}} </td>
                </ng-container>
                <ng-container matColumnDef="accountNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">Ship to Account Number</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.accountNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="accountName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Ship to Account Name</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    {{element.accountName}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="city">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Ship to Account City</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.city}} </td>
                </ng-container>
                <ng-container matColumnDef="state">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Ship to Account State</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.state}} </td>
                </ng-container>
                <ng-container matColumnDef="deliverToAccountNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo  text-center">Deliver To Account Number</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.deliverToAccountNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="deliverToAccountName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Deliver To Account Name</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    {{element.deliverToAccountName}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="itemId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">Item ID</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center">
                    {{element.itemId}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="itemNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">Item Number</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center">
                    {{element.itemNumber}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="itemDescription">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">Item Description</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center">
                    {{element.itemDescription}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="hybridVariety">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-center">Hybrid Variety</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.hybridVariety}} </td>
                </ng-container>
                <ng-container matColumnDef="lastStatusCode">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-center">Last Status Code</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.lastStatusCode}} </td>
                </ng-container>
                <ng-container matColumnDef="nextStatusCode">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Next Status Code</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.nextStatusCode }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="branchPlant">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Branch Plant</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.branchPlant }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="lotNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Lot Number</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.lotNumber }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="location">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Location</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.location }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="transactionUOM">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Transaction UOM</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.transactionUOM }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="transactionQuantity">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Transaction Quantity</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.transactionQuantity | number:'1.4-4'}} </td>
                </ng-container>
                <ng-container matColumnDef="orderLineStatusCode">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Order Line Status Code</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.orderLineStatusCode }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="jdeUpdateDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate  text-center">JDE Update Date</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.jdeUpdateDate | date:'MM/dd/yyyy'}} </td>
                </ng-container>
                <ng-container matColumnDef="jdeUpdateTime">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">JDE Update Time</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.jdeUpdateTime }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="createUser">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Create User</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.createUser}} </td>
                </ng-container>
                <ng-container matColumnDef="createTimeStamp">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Create Time Stamp</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.createTimeStamp | date:'MM/dd/yyyy HH:mm:ss'}} </td>
                </ng-container>
                <ng-container matColumnDef="updateUser">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Update User</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.updateUser}} </td>
                </ng-container>
                <ng-container matColumnDef="updateTimeStamp">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Update Time Stamp</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.updateTimeStamp | date:'MM/dd/yyyy HH:mm:ss'}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="plotSeedReleaseJDESyncColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let row; columns: plotSeedReleaseJDESyncColumns;"></tr>
              </table>
              <div *ngIf="plotSeedDataSource == undefined || (plotSeedDataSource && plotSeedDataSource.data.length == 0)" class="noDataMsg">
                <p class="padding-b47">No Record Found.</p>
              </div>
            </div>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <i class="icon-ico-dealer_icon padding-t10 xs-mr-5" aria-hidden="true"></i>
              <div class="tab-head">
                <h4 class="mt-2 ml-2 mb-0">
                  Evolve Release
                </h4>
              </div>
            </ng-template>
            <div class="fulfill-top-sec">
              <div class="row listing-action-items">
                <div class="col-12">
                  <div class="d-flex justify-content-end">
                    <mat-paginator #plotSeedReleasePaginator [pageSize]="masterConstants.PAGE_SIZE" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS"></mat-paginator>
                  </div>
                </div>
              </div>
            </div>
            <div class="tableContainer activeReturnRequest">
              <table mat-table #plotSeedReleaseTable [dataSource]="plotSeedReleaseDataSource" matSort #plotSeedReleaseSort matSortDirection="desc" class="matTables containerDrafTable">
                <ng-container matColumnDef="releaseId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">PS Release ID</th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    {{element.releaseId}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="releaseItemId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">PS Release Item ID</th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    {{element.releaseItemId}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="releaseItemsLotsId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">PS Release Item Lots ID</th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    {{element.releaseItemsLotsId}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="companyCode">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo  text-center">JDE Company Code</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.companyCode}} </td>
                </ng-container>
                <ng-container matColumnDef="jdeOrderNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">JDE Order Number</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    {{element.jdeOrderNumber}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="jdeOrderType">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">JDE Order Type</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    {{element.jdeOrderType}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="jdeOrderLineNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">JDE Order Line Number</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    {{element.jdeLineNumber}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="customerPO">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Customer PO</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    {{element.customerPO}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="deliveryInstruction">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Delivery Instruction</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    {{element.deliveryInstruction}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="webOrderNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Web Order Number</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    {{element.webOrderNumber}}
                  </td>
                </ng-container>             
                <ng-container matColumnDef="freightHandlingCode">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Freight Handling Code</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.freightHandlingCode}} </td>
                </ng-container>
                <ng-container matColumnDef="orderDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Order Date</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.orderDate | date:'MM/dd/yyyy'}} </td>
                </ng-container>
                <ng-container matColumnDef="requestedDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Requested Date</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.requestedDate | date:'MM/dd/yyyy'}} </td>
                </ng-container>                
                <ng-container matColumnDef="accountNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">Ship to Account Number</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.accountNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="accountName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Ship to Account Name</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    {{element.accountName}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="city">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Ship to Account City</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.city}} </td>
                </ng-container>
                <ng-container matColumnDef="state">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Ship to Account State</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.state}} </td>
                </ng-container>
                <ng-container matColumnDef="deliverToAccountNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo  text-center">Deliver To Account Number</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.deliverToAccountNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="deliverToAccountName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Deliver To Account Name</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    {{element.deliverToAccountName}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="itemId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">Item ID</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center">
                    {{element.itemId}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="itemNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">Item Number</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center">
                    {{element.itemNumber}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="itemDescription">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">Item Description</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center">
                    {{element.itemDescription}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="hybridVariety">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-center">Hybrid Variety</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.hybridVariety}} </td>
                </ng-container>
                <ng-container matColumnDef="branchPlant">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Branch Plant</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.branchPlant }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="lotNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Lot Number</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.lotNumber }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="location">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Location</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.location }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="transactionUOM">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Transaction UOM</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.transactionUOM }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="transactionQuantity">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Transaction Quantity</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.transactionQuantity | number:'1.4-4'}} </td>
                </ng-container>
                <ng-container matColumnDef="createUser">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Create User</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.createUser}} </td>
                </ng-container>
                <ng-container matColumnDef="createTimeStamp">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Create Time Stamp</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.createTimeStamp | date:'MM/dd/yyyy HH:mm:ss'}} </td>
                </ng-container>
                <ng-container matColumnDef="updateUser">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Update User</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.updateUser}} </td>
                </ng-container>
                <ng-container matColumnDef="updateTimeStamp">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Update Time Stamp</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.updateTimeStamp | date:'MM/dd/yyyy HH:mm:ss'}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="plotSeedReleaseOrderColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let row; columns: plotSeedReleaseOrderColumns;"></tr>
              </table>
              <div *ngIf="plotSeedReleaseDataSource == undefined || (plotSeedReleaseDataSource && plotSeedReleaseDataSource.data.length == 0)" class="noDataMsg">
                <p class="padding-b47">No Record Found.</p>
              </div>
            </div>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <i class="icon-ico-dealer_icon padding-t10 xs-mr-5" aria-hidden="true"></i>
              <div class="tab-head">
                <h4 class="mt-2 ml-2 mb-0">
                  Evolve Release Error
                </h4>
              </div>
            </ng-template>
            <div class="fulfill-top-sec">
              <div class="row listing-action-items">
                <div class="col-12">
                  <div class="d-flex justify-content-end">
                    <mat-paginator #plotSeedReleaseErrorPaginator [pageSize]="masterConstants.PAGE_SIZE" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS"></mat-paginator>
                  </div>
                </div>
              </div>
            </div>
            <div class="tableContainer activeReturnRequest">
              <table mat-table #plotSeedReleaseErrorTable [dataSource]="plotSeedReleaseErrorDataSource" matSort #plotSeedReleaseErrorSort matSortDirection="desc" class="matTables containerDrafTable plotSeedReleaseErrorTable">
                <ng-container matColumnDef="releaseErrorId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">PS Release ERROR ID</th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    {{element.releaseErrorId}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="releaseId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">PS Release ID</th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    {{element.releaseId}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="messagePartSeq">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">Message Part Seq</th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    {{element.messagePartSeq}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="releaseMessagePart">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo  text-center">Release Message Part</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.releaseMessagePart}} </td>
                </ng-container>

                <ng-container matColumnDef="accountNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">Ship to Account Number</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.accountNumber}} </td>
                </ng-container>
                <ng-container matColumnDef="accountName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Ship to Account Name</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    {{element.accountName}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="city">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Ship to Account City</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.city}} </td>
                </ng-container>
                <ng-container matColumnDef="state">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Ship to Account State</th>
                  <td mat-cell *matCellDef="let element" class="text-left"> {{element.state}} </td>
                </ng-container>
                <ng-container matColumnDef="webOrderNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Web Order Number</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center ">
                    {{element.webOrderNumber}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="itemId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">Item ID</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center">
                    {{element.itemId}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="itemNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">Item Number</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center">
                    {{element.itemNumber}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="itemDescription">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center">Item Description</th>
                  <td mat-cell *matCellDef="let element" class="order-info text-center">
                    {{element.itemDescription}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="hybridVariety">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-center">Hybrid Variety</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.hybridVariety}} </td>
                </ng-container>
                <ng-container matColumnDef="lotNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Lot Number</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.lotNumber }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="location">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Location</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.location }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="transactionUOM">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Transaction UOM</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.transactionUOM }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="transactionQuantity">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Transaction Quantity</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.transactionQuantity | number:'1.4-4'}} </td>
                </ng-container>
                <ng-container matColumnDef="createUser">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Create User</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.createUser}} </td>
                </ng-container>
                <ng-container matColumnDef="createTimeStamp">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Create Time Stamp</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.createTimeStamp | date:'MM/dd/yyyy HH:mm:ss'}} </td>
                </ng-container>
                <ng-container matColumnDef="updateUser">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Update User</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.updateUser}} </td>
                </ng-container>
                <ng-container matColumnDef="updateTimeStamp">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center">Update Time Stamp</th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{element.updateTimeStamp | date:'MM/dd/yyyy HH:mm:ss'}} </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="plotSeedReleaseErrorColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let row; columns: plotSeedReleaseErrorColumns;"></tr>
              </table>
              <div *ngIf="plotSeedReleaseErrorDataSource == undefined || (plotSeedReleaseErrorDataSource && plotSeedReleaseErrorDataSource.data.length == 0)" class="noDataMsg">
                <p class="padding-b47">No Record Found.</p>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>

